export const TOP_ROUTES = {
	public: 'public',
	resources: 'resources',
	compliance: 'compliance',
	help: 'help',
	account: 'account',
	joinOurNetwork: 'joinournetwork',
	termsAndConditions: 'termsAndconditions',
	privacyStatement: 'privacy',
	memberAgreements: 'memberAgreements',
	switchClinicLocation: 'switchClinicLocation',
	confirmClinicLocation: 'confirmClinicLocation',
	identity: 'identity',
	forms: 'forms',
};

export const PAGE_ROUTES = {
	pageNotFound: 'pagenotfound',
	// Resources
	clientSummaries: 'clientsummaries',
	notifications: 'notifications',
	providerServiceAgreements: 'providerservicesagreements',
	valueAddedProgram: 'valueAddedProgram',
	operationsManual: 'operationsmanual',
	newsletters: 'newsletters',
	providerEducationLibrary: 'providerEducationLibrary',
	practitionerServiceAgreements: 'practitionerservicesagreements',
	practitionerEducationLibrary: 'practitionerEducationLibrary',
	providerPractitionerVirtualServicesAgreement:
		'providerPractitionerVirtualServicesAgreement',
	forms: 'forms',
	// Help
	faq: 'faq',
	// Account
	accountManagement: 'accountManagement',
	createSubAccount: 'createSubAccount',
	manageSubAccounts: 'manageSubAccounts',
	editSubAccounts: 'editSubAccounts',
	eMNRSubmit: 'auth/submit',
};

export const PAGE_PATHS = {
	pageNotFound: `/${TOP_ROUTES.public}/${PAGE_ROUTES.pageNotFound}`,
};

// routes that users should be able to get to when they have nonskipable flow, will NOT be redirected to the flow page
export const nonFlowRoutes = ['/auth/logout'];
